<template>
  <div class="navbar">
    <div class="navbar_left">
      <div>{{system.site_title}}</div>
      <div class="navbar_tip">{{projectName}}&nbsp;&nbsp;&nbsp;&nbsp;V{{version}}</div>
    </div>
    <div class="navbar_right">

      <privilege-btn class="navbar_item" v-if="isFristManager"></privilege-btn>

      <search class="navbar_item"></search>

      <el-dropdown class="navbar_item navbar_dropdown" trigger="click" @command="dropDownChange">
        <span class="navbar_dropdown-link">
          <img src="@/static/icon-user.png" class="navbar_user" :title="username">
          {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="password">{{$ts('修改密码')}}</el-dropdown-item>
          <el-dropdown-item divided command="out">{{$ts('退出登录')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <screenfull class="navbar_item"></screenfull>
      <a class="navbar_item navbar_item-btn navbar_server" href="https://mpkf.weixin.qq.com/"
        target="_blank">{{$ts('客服')}}</a>
      <div class="navbar_item navbar_item-btn navbar_news" @click="messageShow">{{$ts('消息')}}</div>
      <div class="navbar_item navbar_item-btn navbar_help" @click="helpShow">{{$ts('帮助')}}</div>

      <language modal />

    </div>

    <modify-password ref="modifyPassword"></modify-password>

    <message-modal ref="MessageModal"></message-modal>

    <help-modal ref="HelpModal"></help-modal>
  </div>
</template>

<script>
  import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  import Screenfull from './Screenfull.vue'
  import Search from './HeaderSearch.vue'
  import ModifyPassword from './ModifyPassword.vue'
  import MessageModal from './MessageModal.vue'
  import HelpModal from './HelpModal.vue'
  import Language from './Language.vue'
  import PrivilegeBtn from './PrivilegeBtn.vue'
  export default {
    components: {
      Screenfull,
      Search,
      ModifyPassword,
      MessageModal,
      HelpModal,
      Language,
      PrivilegeBtn
    },
    data() {
      return {
        timer: 0,
        count: -1,
        num: 1
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    mounted() {
      if (process.env.NODE_ENV !== 'development') {
        this.getNum()
        this.timer = setInterval(() => {
          this.getNum()
          this.num++
        }, 60000)
      }
    },
    computed: {
      ...mapState(['system', 'version']),
      ...mapGetters(['userInfo']),
      isFristManager() {
        return this.userInfo.uid == 1001;
      },
      username() {
        if (this.userInfo && this.userInfo.username) {
          let username = this.userInfo.username.slice(7, 11);
          let name = this.userInfo.name
          return name + '—' + username;
        }
        return 'admin'
      },
      projectName() {
        let name = '';
        switch (this.$projectType) {
          case 1:
            name = this.$ts('订货云商贸经营管理系统')
            break;
          case 2:
            name = 'ERP system';
            break;
          case 3:
            name = '亿承源副食品配送平台系统';
            break;
          case 4:
            name = '优鲜云采生鲜配送系统';
            break;
          case 5:
            name = '展维美菜ERP系统';
            break;
          case 6:
            name = '商仑供应链ERP系统';
            break;
          default:
            name = this.$ts('蔬果云生鲜ERP系统')
        }
        return name
      }
    },
    methods: {
      /* 修改密码+退出登录 */
      dropDownChange(e) {
        if (e === 'password') {
          this.$refs.modifyPassword.show()
        } else if (e === 'out') {
          this.$store.dispatch('user/logout')
        }
      },
      /* 消息弹框 */
      messageShow() {
        this.$refs.MessageModal.toggle()
      },
      /* 帮助弹窗 */
      helpShow() {
        this.$refs.HelpModal.toggle()
      },
      /* 轮询获取服务器 信息*/
      getNum() {
        this.count++
        this.request({
          url: '/api/notice/noticeNum',
          data: {},
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              if (res.data && this.count) {
                this.$bus.$emit('downloading')
                this.$refs.MessageModal.init();
                this.$refs.MessageModal.toggle(true);
                let audio = new Audio()
                audio.src = "../../static/win.wav"
                audio.play()
              }
            }
            if (res.error_code == 1) {
              this.$message.error(res.error_msg);
            }
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .navbar {
    height: 44px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
    position: relative;

    &_left {
      font-size: 15px;
      color: #333;
      font-weight: bold;
      padding: 0 20px;
      box-sizing: border-box;
      white-space: nowrap;
      display: flex;
      align-items: center;
    }

    &_tip {
      margin-left: 15px;
      font-size: 12px;
      color: #999;
      font-weight: 400;
    }

    &_right {
      display: flex;
      align-items: center;
      padding: 0 20px 0 0;
      overflow-x: auto;
      overflow-y: hidden;

      /* 设置滚动条的样式 */
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      // /* 滚动条滑块 */
      &::-webkit-scrollbar-thumb {
        width: 2px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.2);
      }
    }

    &_item {
      height: 30px;
      line-height: 30px;
      margin-left: 20px;
      cursor: pointer;
      user-select: none;
      white-space: nowrap;
    }

    &_dropdown {
      outline: none;
    }

    &_dropdown-link {
      outline: none !important;
      display: flex;
      align-items: center;
      height: 30px;
    }

    &_user {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }


    &_item-btn {
      font-size: 16px;
      color: #333;
      padding: 0 15px 0 2px;
      background-color: #f5f5f5;
      border-radius: 25px;
      display: flex;
      align-items: center;

      &::before {
        content: "";
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        background-color: #ff904e;
        background-repeat: no-repeat;
        background-size: 18px auto;
        background-position: center;
        border-radius: 50%;
        margin-right: 10px;
      }
    }

    &_server {
      text-decoration: none;
    }

    &_server::before {
      background-color: #14dfd3;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABsElEQVQ4jX3UT4hPURQH8M+IFRY2FgwpCROFBRZihdiIMkTKgqSZjaywsPBnQ7KYksiKxSgLI5KNJiJF8i8WIspCkYUNFr564z7zevMbp07de+73nHfu+d7v60qig/VgN97hN+biKp60oRPG5o7YBUzDD/zCFAygqw1sd9CNQczHQ0xHBfiCJfiMbXj7L6MqUHxD/trlJHMa8dq7k5wvmJ11vD7sKQd7OiS2vbdglzcLPEtysQN4PD+R5FNdYFmSry3goSQrxkmu/VuStRULO/CmMcj1ZfrHsXQMP6P2AFsnYiGelvAmHMTqEjuLm4WZD60Cj7C4orHidwGuYTP24X0BVTQeQPWhl5hUur2PGyO0JhkqU72bZGq538kkaxr3nZVkuAz6cJIrJee1jNr2Au4vkTONAn0ltrfsj9ZZ1eZIWZ8u+xllvapRYGaSU42uVtaPrgZsTDLYgapOPi/JxyS7mg+p8oEkW/6TWHWxrszhTh1vqvEc+jC7pcrnRdoVtZWwKpUe6yTnV4X3S9iPyRjGdbwoj6sXt3BvPDlXVv1M+vETj/Edi4rUh3D7HxJ/AAWBE1Gg9P5DAAAAAElFTkSuQmCC);
      background-size: 14px auto;
    }

    &_news::before {
      background-color: #ff904e;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAABcElEQVQ4jZ2Tvy+DYRDHP6+kjaGDaFqSIgYGW6OLQSTCZOhiEYOERCwixD8gMfofsFlE/BhM0hSLSC0kdGEyqZQEMfnK09yrT+StRC+53s/v3dO7e5EUxTOSTiRVVKdnSQVJcxH5BO7Ho2FgD0gBl8ApULZwHzACDAFVYBIo/EC9qrPW+1BSOqqrcbukXctdCP1hcMwCqxHARrxomAm/kKOdBoC/eMuwtULzodEkO1pySklS0SsyKKnVswck9Xt2TFLOs88kXTvlVdKGOVesw7nZXd76M+bbN3vd7DV3Ji3AJ5CwJb6brJr8Cpfr6S8m30zGgMBVPJZU9p7a82tWKVs5DXJuJF04ZdSemmxi2AnD5sPLfqg9D3r5H90BbUBnWLnDKm9LCiI6R/GBYbr9g3Q8boG4zcA/AZ+nJT1Zbjbqo00CFaAE5Mx3BdzbxtzfzgJx4AiYAj5CsF8oA9zaCSwDaSBvfje/R6AIbJpeJ+AbG7WnfCG//HsAAAAASUVORK5CYII=);
    }

    &_help::before {
      background-color: #03a9f4;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABlklEQVQ4jX2UyysHURiGHySXLFwiWUhyzcJGyo6NSKFESVYWWCh/BlsLewspOyJKIUnKpSi5L61EhBTy6vh9w5g5P299p5nzPt/3zZkzZ5Dkiz5Ju5Le9Kt3SXuSBjw8KW4IqQ5YAsqAPWAVuDC7AmgFmoAboBM4/EkNVW2x3seSqn1dLcol7RvbHswHZpUZM57EZDFtOXXhpd0CT0A5cQ0DBcACcBJxj4BSIM9V7rbKRZHOWZIu9FdDESbH3EEMPvQ8/qVBBZLSJa3bfUaEO5B0kwpUArOxBcE1MA7cAe/Ams2nRbg5oATr0u15onBUGrfi8dqckZqkS1iFwBmwCbTHXPhwQ1DIt1uBlo1riTkJ1brRbf8V8AA0xJCE+oEXYDHmJLTz/Z4l9dr6cz3rdzEpaV5SpsdLt9yRYOJR0pkHdPFscLbHcwf7NXxE6g2e8sB5kvI98xOW0xgu5KLDjG1Jxf98CoWSNoztSfYbabTfiNvyLWAFODWvBmgDmoF7oAvY/slM0nXU3tln6KS563NJYzFe4guErLQmQxlPuwAAAABJRU5ErkJggg==);
      background-size: 14px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/index.vue